import { z } from 'zod';

export const WriteBackToAdpStrategy = z.object({
  type: z.literal('adp'),
});

export type WriteBackToAdpStrategy = z.infer<typeof WriteBackToAdpStrategy>;
